import type { InjectionKey, Ref } from 'vue';

/**
 * Final Dividends — 멤버(주주) 목록 공유 API.
 *   Voucher(주주 1인당 1부) 반복과 Minutes(Multiple) 의 주주×금액 표가 **동일 멤버셋**을 쓰도록
 *   패키지가 memberIds 를 provide 하고, 각 멤버는 `mem_${id}/` 스코프 키(member_name/member_address/
 *   number_of_shares/amount_to_receive/dividend_number/payment_date)로 값을 보관한다.
 */
export interface DivMembersApi {
  ids: Ref<number[]>;
  add: () => void;
  remove: (id: number) => void;
}

export const DIV_MEMBERS: InjectionKey<DivMembersApi> = Symbol('finalDividendsMembers');

/** 멤버 스코프 안에서 문서별로 갈리지 않고 그 멤버에 귀속되는 키(최상위 유출 차단용). */
export const MEMBER_OWNED = [
  'member_name', 'member_address', 'number_of_shares', 'amount_to_receive',
  'dividend_number', 'payment_date',
];
